import { Box, Typography } from "@mui/material";

import Halbaddierer from "./GatterAppComponents/Addierer/Halbaddierer";
import Volladdierer from "./GatterAppComponents/Addierer/Volladdierer";
import Tester from "./GatterAppComponents/Addierer/Tester";
import NeutralTester from "./GatterAppComponents/Addierer/neutralTester";
import AppContentWrapper from "../../2_ksbHub/components/AppContentWrapper";

export default function GatterApp() {
  return (
    <AppContentWrapper scrollable={false}>
      <Box sx={{ textAlign: "center", mt: "1rem" }}>
        <Typography variant="h5" fontWeight="bold" color="primary">
          Halbaddierer
        </Typography>
        <Halbaddierer />
      </Box>

      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h5" fontWeight="bold" color="primary">
          Volladdierer
        </Typography>
        <Volladdierer />
      </Box>

      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h5" fontWeight="bold" color="primary">
          Testübung
        </Typography>
        <Tester />
      </Box>

      <Box sx={{ textAlign: "center", pb: "3rem" }}>
        <Typography variant="h5" fontWeight="bold" color="primary">
          Neutraler Tester (Prüfungsblatt)
        </Typography>
        <NeutralTester />
      </Box>
    </AppContentWrapper>
  );
}
